import React, { useState, useMemo,useEffect } from "react";
import DialogComp from "../../components/Dialog-Popup";
import Button from '../../components/Button'

import "./style.css";
import {
    TextField,
    Grid,
    Typography,
} from "@mui/material";
import{useEditResponseQuery,useUpdateResponseMutation} from "../../reducer/updateProfileReducer"

const UserInformation = ({ inEditMode,handleEditClick }) => {
    const [openPopup, setOpenPopup] = useState(false);
    const [popuptitle, SetPopupTitle] = useState("");
    const [popupContent, SetPopupContent] = useState("");
    const [buttonArr, setButtonArr] = useState([]);
   

    const [selectedValue, setSelectedValue] = React.useState('');
    const defaultUserInformation = {
        firstName: 'Anna',
        lastName: 'Joe',
        email: 'anna@gmail.com',
        contact: '+00 12 34 44 55 33',
        nationalId: '12345678'
    }
    const [userInfo, setUserInfo] = React.useState({})
    const {
        data: addressList,
        isSuccess,
        isError2,
        isLoading,
        error2,
      } = useEditResponseQuery();
      console.log("addressList",addressList)
    
    
      useEffect(()=>{
        if(isSuccess){
       
        setUserInfo({...addressList,'phone':addressList.phone.substring(3)})
        setSelectedValue(addressList.sex)
        }
      },[isLoading,isSuccess]);
   

     const gendername=selectedValue==="M"?"Male":selectedValue==="F"?"Female":"Other"
      function handlePopupopen() {
        setOpenPopup(true);
        SetPopupTitle("Updated Details");
        SetPopupContent("Successfully changed and updated all the details done in the profile."
        );
        let btnValues = [
            {
                id: "1",
                value: "OK",
                color: "borderLess",
                fontSize: "16px",
                functionCall: handleClose,
            }
        ];
        setButtonArr(btnValues);
    
    }
    const handleClose = () => {
         handleEditClick(false)
        setOpenPopup(false)
      }

    const handleValueChange = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        console.log('name',name)
        setUserInfo({
            ...userInfo,
            [name]: value
        })
    }
    const styles = {
        borderColor: {
            '& .MuiOutlinedInput-root': {
                border: '1px solid #3c8c9e !important'
            },
            '& .MuiOutlinedInput-root.Mui-disabled': {
                border: '1px solid #E2E2E2 !important',
                fontSize: '16px !important'
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none'
            },
            "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#000000",
            },
        },

    }
    const handleChange = (event) => {
        console.log('selected',event.target.value)
        setSelectedValue(event.target.value);
    };
   
   
    const [
        updateResponse,
        { isLoading2, isSuccess2, isError, isFetching, error, data: responseData },] = useUpdateResponseMutation();
    
        async function  handleSaveChanges() {
          const paramsData = {
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            email: userInfo.email,
            phone:"+91" + userInfo.phone,
            nationalId:userInfo.nationalId,
            sex:selectedValue,
            userType: "A",
            address: {
              addressType: "B",
              name: "Address Name hshs",
              address1: "address1",
              address2: "address2",
              address3: "address3",
              city: "Pune",
              state: "MH",
              country: "INDIA",
              zip: "411057"
            },
            profileComplete: true
          };
         
          try {
            const response = await updateResponse({ paramsData });
            if (response) {
              console.log('response',response)
              handlePopupopen() 
              
            }
            else if (response.error) {
         
            }
          } catch (err) {
            console.log("error", err);
          }
        }
    
    return (
        <Grid display='flex' flexDirection='column' className="user-info">
            <Grid style={{ display: 'flex' }} >
                <Grid display='flex' flexDirection='column'>
                    <Typography htmlFor="name" sx={{ fontSize: '12px', color: '#000000' }}>
                        First name
                    </Typography>
                    <TextField
                        sx={styles.borderColor}
                        style={{ fontFamily: 'Rubik' }}
                        size="small"
                        fullWidth
                        name='firstName'
                        disabled={!inEditMode}
                        focused={false}
                        value={userInfo?.firstName}
                        placeholder="Add First Name"
                        onChange={handleValueChange}
                    />
                </Grid>
                <Grid display='flex' flexDirection='column' style={{ marginLeft: '20px' }}>
                    <Typography htmlFor="name" sx={{ fontSize: '12px', color: '#000000' }}>
                        Last name
                    </Typography>
                    <TextField
                        sx={styles.borderColor}
                        style={{ fontFamily: 'Rubik' }}
                        name="lastName"
                        size="small"
                        fullWidth
                        disabled={!inEditMode}
                        focused={false}
                        value={userInfo?.lastName}
                        placeholder="Add Last Name"
                        onChange={handleValueChange}
                    />
                </Grid>
            </Grid>
            <Grid style={{ display: 'flex', marginTop: '20px' }} >
                <Grid display='flex' flexDirection='column'>
                    <Typography htmlFor="name" sx={{ fontSize: '12px', color: '#000000' }}>
                        Email ID
                    </Typography>
                    <TextField
                         sx={styles.borderColor}
                        style={{ fontFamily: 'Rubik' }}
                        value={userInfo?.email}
                        size="small"
                        name="email"
                        disabled={!inEditMode}
                        focused={false}
                        placeholder="Add Email"
                        fullWidth
                      
                        onChange={handleValueChange}
                    />
                </Grid>
                <Grid display='flex' flexDirection='column' style={{ marginLeft: '20px' }}>
                    <Typography htmlFor="name" sx={{ fontSize: '12px', color: '#000000' }}>
                        Contact number
                    </Typography>
                    <TextField
                        sx={styles.borderColor}
                        style={{ fontFamily: 'Rubik' }}
                        size="small"
                        name='phone'
                        disabled={!inEditMode}
                        focused={false}
                        placeholder="Add Contact"
                        fullWidth
                        value={userInfo?.phone}
                        onChange={handleValueChange}
                    />
                </Grid>
            </Grid>
            <Grid style={{ display: 'flex', marginTop: '20px' }} >
                <Grid display='flex' flexDirection='column' style={{ marginLeft: inEditMode? '-40px' : '-112px' }}>
                    <Typography htmlFor="name" sx={{ fontSize: '12px', color: '#000000' }}>
                        National ID
                    </Typography>
                    <TextField
                        sx={styles.borderColor}
                        style={{ fontFamily: 'Rubik' }}
                        size="small"
                        disabled={!inEditMode}
                        focused={false}
                        name='nationalId'
                        placeholder="Add National ID"
                        fullWidth
                        value={userInfo.nationalId}
                        onChange={(e) => handleValueChange(e)}
                    />
                </Grid>
                {inEditMode ?
                    <Grid display='flex' flexDirection='column' style={{ marginLeft: '25px' }}>
                        <Typography htmlFor="name" sx={{ fontSize: '12px', color: '#000000' }}>
                            Select your Gender
                        </Typography>
                        <Grid display='flex'>
                        <Grid display='flex' style={{ marginLeft: '0px', paddingTop: '10px' }}>
                            <input type="radio"
                                style={{ height: '15px', width: '20px' }}
                                checked={selectedValue==="M"}
                                onChange={handleChange}
                                value="M"
                                name="radio-buttons"
                            />
                            <Typography style={{ fontSize: '16px', marginTop: '-5px' }}>Male</Typography>
                        </Grid>
                        <Grid display='flex' style={{ marginLeft: '15px', paddingTop: '10px' }}>
                            <input type="radio"
                                style={{ height: '15px', width: '20px' }}
                                checked={selectedValue==="F"}
                                onChange={handleChange}
                                value="F"
                                name="radio-buttons"
                            />
                            <Typography style={{ fontSize: '16px', marginTop: '-5px' }}>Female</Typography>
                        </Grid>
                        <Grid display='flex' style={{ marginLeft: '15px', paddingTop: '10px' }}>
                            <input type="radio"
                                style={{ height: '15px', width: '20px' }}
                                checked={selectedValue==="O"}
                                onChange={handleChange}
                                value="O"
                                name="radio-buttons"
                            />
                            <Typography style={{ fontSize: '16px', marginTop: '-5px' }}>Other</Typography>
                        </Grid>
                        </Grid>
                    </Grid>
                    :
                    <Grid display='flex' style={{ marginLeft: '22px', marginTop: '27px' }}>
                        <Typography htmlFor="name" sx={{ fontSize: '15px', color: '#000000' }}>
                            Gender
                        </Typography>
                    <Grid display='flex' style={{ marginLeft: '0px', paddingTop: '5px' }}>
                            <input type="radio"
                                style={{ height: '15px', width: '45px' }}
                                checked={selectedValue}
                                onChange={handleChange}
                                value="M"
                                name="radio-buttons"
                            />
                            <Typography style={{ fontSize: '16px', marginTop: '-5px' }}>{gendername}</Typography>
                        </Grid>

                    </Grid>
                }




            </Grid>
          {inEditMode?(<div className="footer">
      <Grid style={{ marginRight: '30px' }}>
        <Button
          color="cancel"
          opacity="1"
          name="Cancel Changes"
          onClick={() => {
            handleEditClick(false)
          }}
        />
      </Grid>
      <Grid>
        <Button
          color="green"
          opacity="1"
          name="Save Details"
          onClick={handleSaveChanges}
        />
      </Grid>
      <DialogComp
                openPopup={openPopup}
                popuptitle={popuptitle}
                popupContent={popupContent}
                buttonValue={buttonArr}
            />
    </div>):null}
        </Grid>
    );
};

export default UserInformation;